module.exports = __webpack_public_path__ + "static/media/greyCross.37e0cf3c.svg";